var render, staticRenderFns
import script from "./couponsReceive.vue?vue&type=script&lang=js"
export * from "./couponsReceive.vue?vue&type=script&lang=js"
import style0 from "./couponsReceive.vue?vue&type=style&index=0&id=a150b340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a150b340",
  null
  
)

export default component.exports